import React  , { Component } from 'react'

import {  HomeSlider,
          HomeDeals,
          VideoSliderItem,
          PostSliderItem,
          HomeTitle ,
          ResponsiveYouTubeIframe        } from '../../Components/UI/UI'

import {    newPosts  } from "../../Data/Data";
import { getWeather } from "../../Utility/Utility";
import Menu from '../../Components/Menu/Menu'
import Footer from '../../Components/Footer/Footer'

import "../innerPage.css"
import "./GalileePage.css"

class GalileePage extends Component {

  state = {
   
    telAvivWeather : 0,
    waterTemp : 0,
    GalileeWeather : 0,

  }

  componentDidMount () {

    getWeather((Weather)=>{
    
      this.setState({
        telAvivWeather : Weather.telAvivWeather,
        waterTemp : Weather.water_temp,
        GalileeWeather : Weather.GalileeWeather,
      })

      
    });
    

     
  }
  


  render(){
    // get all posts 
    const  posts = [ ...newPosts ] ;

    // get non video posts and culinary posts
    const GalileePosts = posts.filter((o , i )=>{
       return (o.ctg === 'galilee'  ||  o.ctg === 'galilee') && o.isDouble === false;
    })

    // const thingsToDoPosts = [ ...posts ];


    const postsHtml = GalileePosts.map( (o,i) => {
        // console.log('o' , o);
        let cssClass="";
        let html ="";
        if ( i % 4 === 0 ) {
          cssClass =" first";
        }
        let url = null;
        let component = null;
        
        if (o.isVid === true) {
         
          url  = "/Posts/Videos/" + o.ctg  + '/' + o.id;
          component = <VideoSliderItem  
                        key={i}
                        title={o.title}
                        desc={""}
                        img= {o.img}
                        link={url}
                        cssClass={cssClass} />
        }else {
          // url = "/Posts/" + o.id ;
          url  = "/Posts/" + o.ctg  + '/' + o.id;
          component = <PostSliderItem  
                          key={i}
                          title={o.title}
                          desc={""}
                          img= {o.img}
                          link={url}
                          cssClass={cssClass} />
        }

        return component;
        
    });

    return(
      <div className="inner-page align-center page-galilee">
        <Menu />
        <HomeSlider waterTemp={this.state.waterTemp} telAvivWeather={this.state.telAvivWeather} GalileeWeather={this.state.GalileeWeather} />
        
        <section className="live-shows-section">
          <div className="container">
            <HomeTitle>
              GALILEE 
            </HomeTitle>
            <ResponsiveYouTubeIframe vidId={"FYtk8JMMZRE"} />
            <div className="live-shows-wrapper">
              {postsHtml}
            </div>
          </div>
        </section>
        <Footer />
      </div>
    )
  }

}



export default GalileePage


// WEBPACK FOOTER //
// ./src/Pages/GalileePage/GalileePage.js